import React from "react";
import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { API_BASE } from "../utils/draftutils";

export default function ProtectedRoute({ children, allowedRoles = [] }) {
  const [state, setState] = useState({ loading: true, ok: false, role: null, user: null });
  const location = useLocation();

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const res = await fetch(`${API_BASE}/api/auth/me`, { credentials: "include" });

        if (!res.ok) throw new Error("non autorizzato");
        const me = await res.json(); 
        const role = me.tipoUtente;
        const ok = allowedRoles.length ? allowedRoles.includes(role) : true;
        const user = me.user;

        if (alive) setState({ loading: false, ok, role, user });
      } catch {
        if (alive) setState({ loading: false, ok: false, role: null, user: null });
      }
    })();
    return () => { alive = false; };
  }, [allowedRoles]);

  if (state.loading) return <div>Verifica accesso…</div>;
  if (!state.ok) {
    // se non autorizzato: manda alla home oppure alla root del ruolo corrente, se noto
    if (state.role === "FRUITORE") return <Navigate to="/menufruitore" replace />;
    if (state.role === "CONFIGURATORE") return <Navigate to="/menuconfig" replace />;
    return <Navigate to="/" replace state={{ from: location }} />;
  }
  return React.cloneElement(children, { role: state.role, username: state.user  });
}
